import React from 'react'
import AceEditor from 'react-ace'
import 'brace/mode/javascript'
import 'brace/theme/github'
import { Alert, Row, Col, Glyphicon, Button } from 'react-bootstrap'
import { demo } from '../demo'

export default class Input extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      alert: {
        level: null,
        message: null
      },
      isAbleButton: false,
      directInput: '',
      showModal: false
    }
    this.handleChangeInput = this.handleChangeInput.bind(this)
    this.parseInputToJson = this.parseInputToJson.bind(this)
  }

  componentDidUpdate (prevProps, prevState) {
    if (prevState.directInput !== this.state.directInput) {
      this.parseInputToJson(this.state.directInput)
    }

    if (JSON.stringify(prevProps.contents) !== JSON.stringify(this.props.contents)) {
      this.props.setInputKeys(this.props.contents, this.props.inputKey)
      if (this.props.contents && Object.keys(this.props.contents).length > 0) {
        const input = JSON.stringify(this.props.contents, null, '\t')
        this.setState({directInput: input})
      }
    }

    if (prevProps.inputKeys !== this.props.inputKeys  &&
      Object.keys(this.props.inputKeys).length > 0 && this.state.directInput) {
      this.props.initContextList(this.props)
    }

    if (this.props.contextsFromVocabularies.length > 0 &&
      (prevProps.contextsFromVocabularies !== this.props.contextsFromVocabularies || prevProps.inputKeys !== this.props.inputKeys)) {
      const context = Object.keys(this.props.selectedContext).length > 0 ?
        this.props.contextsFromVocabularies.filter(v => v.name === this.props.selectedContext.name)[0]
        : this.props.contextsFromVocabularies[0]
      this.props.setSelectedVocabulary(this.props.inputKeys, context)
    }

    return true
  }

  // exampleボタン押下
  handleClickShowModal () {
    this.setState({showModal: ! this.state.showModal})
  }

  // exampleモーダルから項目選択
  handleClickDemo (e, file) {
    e.preventDefault()
    this.props.handleSelectDemo(file)
    this.setState({showModal: false})
  }

  // JSON編集エリアを変更（直接入力時）
  handleChangeInput (newValue, event) {
    this.setState({directInput: newValue})
  }

  // JSON編集エリアを文字列からオブジェクト型へ変更
  parseInputToJson (directInput) {
    if (directInput === '') {
      this.props.setContents({})
      return
    }
    try {
      this.props.setContents(JSON.parse(directInput))
      this.setState({
        isAbleButton: true,
        alert: {level: null, message: null},
      })
    } catch (error) {
      this.setState({
        isAbleButton: false,
        alert: {
          level: 'warning',
          message: `"${error.message}". Please edit or re-upload.`,
        }
      })
    }
  }

  render () {

    return (
      <React.Fragment>
        <Row className="flow_border">
          <div className="row_heading">
            <span className="heading_text">Input</span>
            <p className="border_button" onClick={e => this.handleClickShowModal()} id="selectExample">
              <span className="glyphicon glyphicon-folder-open"/>example
            </p>
          </div>
          <div className="button_wrapper">
            <Button id="uploadJson" className="green_button" onClick={() => this.props.handleClickUpload(true, true)}>
              <Glyphicon glyph="file"/> Upload JSON
            </Button>
          </div>

          <div className="separate">
            <div className="separate__border"/>
            <p className="separate__text">or</p>
            <div className="separate__border"/>
          </div>

          <Col md={12} className="input_code">
            {this.state.alert.message ? <Alert bsStyle={this.state.alert.level}>
                {this.state.alert.message}
              </Alert>
              : null
            }
            <AceEditor
              mode="javascript"
              theme="github"
              id="directInput"
              width="100%"
              showPrintMargin={false}
              onChange={this.handleChangeInput}
              value={this.state.directInput}
              name="directInput"
              editorProps={{$blockScrolling: true}}
            />
          </Col>
        </Row>
        {((() => {
          if ( this.state.showModal ) {
            return <section className="modal modal--example">
              <div className="modal__inner">
                <div className="close_button_wrapper">
                  <span className="close_button" onClick={e => this.handleClickShowModal()}>×</span>
                </div>
                <h3 className="modal__heading">example</h3>
{/*
                <input type="text" className="modal__input" placeholder="search"/>
*/}
                <ul className="modal__list">
                  {
                    demo.map((file, i) => {
                      return <li key={i} className="modal__list_item" onClick={(e) => this.handleClickDemo(e, file)}>
                        {file.name}
                        </li>
                    })
                  }
                </ul>
              </div>
            </section>
          }
        }))()}

      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Input.js